import React, { Component } from "react";
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import {getFavoriteTopics,removeFavoriteTopics,addFavoriteTopics,sectionlist_all} from '../config/Variables';
export default class FetchOwnSectionspopup extends Component {
  constructor() {
    super();
    this.state = {
      hobbies: [],
      tid: '',
      messagelog: '',
      isLoading: true,
      users: [],
      numberstid: [],
      error: null
    }
    this.handleInputChangeSection = this.handleInputChangeSection.bind(this);
    this.RemovetidSection = this.RemovetidSection.bind(this);

  }
 
  handleInputChangeSection(event) {
    const target = event.target;
    var value = target.value;
    if (target.checked) {
      this.state.hobbies.push(value);
    } else {
      this.state.hobbies.splice(value, 1);
    }
  }

  async RemovetidSection(event) {

    const target = event.target;
    var value = target.value;

    if (event.target.checked) {
      this.state.hobbies.push(value);
      // this.setState({messagelog:"اختر الكاتب المفضل لديك"});
    } else {
      const index = (this.state.hobbies).indexOf(parseInt(value, 2));


      for (var i = 0; i < this.state.hobbies.length; i++) {

        if (this.state.hobbies[i] == value) {
          this.state.hobbies.splice(i, 1);
        }

      }
      if (localStorage.getItem('user-info')) {
        const tid = value

        let item = { tid };
        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(removeFavoriteTopics, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
          //localStorage.setItem("user-info", JSON.stringify(result));
          //history('/add');

        }
      }
      // this.state.hobbies.splice(value, 1);
    }
  }



  async submitsection() {
    const tid = this.state.hobbies.join(',')
    if (tid == "") {
      this.setState({ messagelog: "اختر الكاتب المفضل لديك" });
    } else {

      if (localStorage.getItem('user-info')) {


        let item = { tid };
        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(addFavoriteTopics, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
          this.props.fetchownusercallback(this.state.hobbies);

        }

      }
    }



    // console.warn(this.state)
  }
  getFetchUsers() {
    var numberstid_constant=[];
    var numberstid_hobbies=[];
    let user = JSON.parse(localStorage.getItem('user-info'))
    let datt = fetch(getFavoriteTopics, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json',
        "Authorization": "Bearer " + user.token.access_token,
      },
      body: JSON.stringify(this.state)
    }).then(response => response.json())
      .then(data => {
        data.data.map(({ tid }, index2) => {
          numberstid_constant.push(tid);
          numberstid_hobbies.push(tid);
        });
     

    this.setState({
      loading: true
    }, () => {
      fetch(sectionlist_all).then(res => res.json()).then(result => this.setState({
        loading: false,
        users: result.rows,
        numberstid: numberstid_constant,
        hobbies:numberstid_hobbies
      })).catch(console.log);
    });
  });
  }


  componentDidMount() {
    this.getFetchUsers();
  }

  render() {
    const {
      users,
      error
    } = this.state;
    var xxx=this.props.userslist;
    return (
      <div className="modal-wrap" data-modal="modal-tags-checked" id="tagsCheckedModal">
        <div className="modal-overlay modal-toggle"></div>
        <div className="modal-wrapper modal-transition">
          <div className="modal-before">
            <button className="modal-close">
              <span aria-hidden="true">&times;</span>
            </button>
            <button onClick={() => this.submitsection()} className="button modal-close primary-light rounded select-all"><i className="icomoon-icon icon-check-green"></i><span aria-hidden="true"> تم </span></button>
          </div>
          <div className="modal-inner">
            <div className="topper-title text-center margin-bottom-3">
              <h3>ما هي اهتماماتك</h3>
              <p>اختر كتابك المفضلين لتحصل علي افضل تجربة  </p>
            </div>

            <div className="vertical-scroll-wrapper">
              <div className="vertical-scroll-inner">
                <div className="tags-list v-inner-scroll v-scroller _js ">




                  <React.Fragment>
                    {

xxx.map(({ name, tid }, index) => {
                        const fruitss = this.state.numberstid;

                        const ttt = parseInt(tid);

                        const ss = fruitss.includes(ttt); //true
                        if (ss) {
                          return (


                            <div className="tag-option" key={index}>
                              <label for={`custom-section-checkbox-${index}`} className="multi-check">
                                <input type="checkbox" onTouchEnd={this.RemovetidSection} onClick={this.RemovetidSection} defaultChecked={true} defaultValue={`${tid}`} id={`custom-section-checkbox-${index}`} name="hobbies" className="form-check" onChange={this.handleInputChangeSection} />
                                <div className="tag">{name}</div>
                              </label>
                            </div>

                          );

                        } else {

                        }
                      })
                    }
                  </React.Fragment>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    );
  }
}
